import { Environment } from './environment.model';
/* Environment used for dynamic environments. Properties are set with
 * with placeholder strings which are replaced by dynamic values during the
 * build
 */

export const environment: Environment = {
  isProd: false,
  isLocal: false,
  assetsHost: 'https://zav-stage.westermann.de',
  apiUrl: 'https://refactor-pixl-1179-remove-datx.backend.review.zav.westermann.de/api/v2',
  learningSectionPreviewHost: 'https://lernmodule.stage.westermann.de',
  learningSectionPreviewToken: '68e647c8fa2883318365e3921e527dd5',
  name: 'refactor-pixl-1179-remove-datx',
  sentry: {
    // disabled in feature branches
    dsn: ''
  },
  playerBaseUrl: 'https://player2.zav-stage.westermann.de',
  backendUrl: 'https://refactor-pixl-1179-remove-datx.backend.review.zav.westermann.de'
};
